import { Component, OnInit, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { Funcionalidad } from '../../_models/funcionalidad';
import { NavService } from '../../_services/_nav.service';
import { Router } from '@angular/router';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { Sincronizacion } from '../../_models/sincronizacion';
import { SincronizacionService } from '../../_services/sincronizacion.service';
@Component({
  selector: 'app-sincronizacion-listado',
  templateUrl: 'sincronizacion-listado.component.html'
})

export class SincronizacionListadoComponent implements OnInit{

  sincronizaciones: Sincronizacion[] = [];
  carTabla = true;
  columnas: any[];
  busqueda: string;
  @ViewChild('dt', { static: true }) tabla: Table;
  menu: Funcionalidad = new Funcionalidad();

  constructor(private sinServicio: SincronizacionService, private navServicio: NavService, private router: Router, private autServicio: AutenticacionService){  }

  ngOnInit(): void {
    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/sincronizacion' );
    if ( mn ) {
      this.menu = mn;
    }

    this.columnas = [
      { field: 'codigo', header: this.navServicio.buscarMensaje( 'SINCRONIZACION.LBL_CODIGO' ), sort: true },
      { field: 'tabla', header: this.navServicio.buscarMensaje( 'SINCRONIZACION.LBL_TABLA' ), sort: true },
      { field: 'indicadorTablaEstatica', header: this.navServicio.buscarMensaje( 'SINCRONIZACION.LBL_SINCRONIZACION' ), sort: true },
      { field: 'fechaSincronizacion', header: this.navServicio.buscarMensaje( 'SINCRONIZACION.LBL_ULTIMAACTUALIZACION' ), sort: true },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
    this.busqueda = this.navServicio.getSearch( 'sincronizacion.component' );

    this.sinServicio.listado().subscribe( sincronizaciones => {
      this.sincronizaciones = sincronizaciones;
      this.carTabla = false;
      this.tabla.filterGlobal( this.busqueda, 'contains' );
    } );
  }

  crear(){
    this.router.navigate(['apl/sincronizacion/agregar']);
  }

  editar( sincronizacion: Sincronizacion ) {
    this.router.navigate( [ 'apl/sincronizacion/actualizar/' + sincronizacion.idSincronizacion ] )
  }

  setBusqueda() {
    this.navServicio.setSearch( 'sincronizacion.component', this.busqueda );
  }
}
